// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { minutesToMilliseconds as fn } from "../minutesToMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const minutesToMilliseconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default minutesToMilliseconds;
